<template>
  <div>
    <v-layout v-if="!dialog" wrap>
      <v-flex xs12 md12 style="margin-top: 10px">
        <v-card :outlined="true">
          <v-card-title>
            Reward Delivery
            <v-spacer></v-spacer>
            <v-row no-gutters>
              <v-col>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="ค้นหา"
                  class="mr-2"
                  outlined
                  dense
                  :hide-details="true"
                  @keydown.enter="_getByQuery"
                />
              </v-col>
              <v-col cols="4">
                <v-select
                  v-model="status"
                  :items="statusList"
                  item-text="name"
                  item-value="value"
                  label="สถานะ"
                  class="mr-2"
                  :hide-details="true"
                  outlined
                  dense
                  @change="_getByQuery"
                />
              </v-col>
            </v-row>
            <v-btn
              class="chang-btn"
              :loading="loading"
              color="#006b35"
              @click="_export()"
            >
              Export
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-card class="mb-4">
              <v-card-text>
                <v-data-table
                  class="clean-tb"
                  item-key="index"
                  :headers="headers"
                  :items="indexedItems"
                  :footer-props="{ 'items-per-page-options': $itemsPerPage }"
                  :items-per-page="limit"
                  :loading="loading"
                  :options.sync="options"
                  :server-items-length="countItems"
                  no-data-text="ไม่พบข้อมูลหรือไม่มีสิทธิเข้าถึงข้อมูล"
                  no-results-text="ไม่พบข้อมูลหรือไม่มีสิทธิเข้าถึงข้อมูล"
                >
                  <template v-slot:item.createdAt="{ item }">
                    {{ item.createdAt && moment(item.createdAt).format("DD/MM/YYYY HH:mm") || '-' }}
                  </template>
                  <template v-slot:item.shippedAt="{ item }">
                    {{ item.shippedAt && moment(item.shippedAt).format("DD/MM/YYYY HH:mm") || '-' }}
                  </template>
                  <template v-slot:item.receivedAt="{ item }">
                    {{ item.receivedAt && moment(item.receivedAt).format("DD/MM/YYYY HH:mm") || '-' }}
                  </template>
                  <template v-slot:item.deliveryStatus="{ item }">
                    <span
                      :class="`${
                        item.deliveryStatus === 'completed'
                          ? 'green-text'
                          : item.deliveryStatus === 'to-ship'
                          ? 'yellow-text'
                          : 'blue-text'
                      }`"
                      >{{
                        capitalize(
                          item.deliveryStatus === "completed"
                            ? item.deliveryStatus
                            : item.deliveryStatus === "to-ship"
                            ? "Waiting for delivery"
                            : "Delivery"
                        )
                      }}</span
                    >
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import fileDownload from "js-file-download";

import StampRewardDeliveryModel from "@/store/models/changtt/stampRewardDelivery";

export default {
  name: "AreaPromoterRewardDeliveryComponent",
  props: {
    id: {
      type: Number,
    },
  },
  computed: {
    indexedItems() {
      return (
        this.items.map((item, index) => ({
          index: index + 1,
          areaPromoter:
            item.shipper &&
            `${item.shipper.firstName} ${item.shipper.lastName}`,
          ...item,
        })) || []
      );
    },
  },
  data() {
    return {
      search: "",
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      limit: 10,
      countItems: 0,
      headers: [
        {
          text: "No",
          value: "index",
          sortable: false,
        },
        {
          text: "Achieve Date",
          value: "createdAt",
          sortable: false,
        },
        {
          text: "Ship Date",
          value: "shippedAt",
          sortable: false,
        },
        {
          text: "Receive Date",
          value: "receivedAt",
          sortable: false,
        },
        { text: "Mission", value: "mission.title", sortable: false },
        {
          text: "Shop",
          value: "shop.name",
          sortable: false,
        },
        {
          text: "Area Promoter",
          value: "areaPromoter",
          sortable: false,
        },
        {
          text: "Status Reward",
          value: "deliveryStatus",
          sortable: false,
        },
      ],
      items: [],
      dialog: false,
      status: "to-ship",
      statusList: [
        { name: "Delivery", value: "to-receive" },
        { name: "Waiting for delivery", value: "to-ship" },
        { name: "Completed", value: "completed" },
      ],
    };
  },
  watch: {
    options: {
      handler(ne, pe) {
        // Page
        if (ne.page != pe.page || ne.itemsPerPage != pe.itemsPerPage) {
          this.fetchData();
        }
      },
      deep: true,
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    moment,
    capitalize(text) {
      return _.capitalize(text);
    },
    async fetchData() {
      this.loading = true;
      let options = {
        params: {
          cardId: this.id,
        },
      };

      if (this.search) {
        options.params.query = this.search;
      }

      if (this.options && this.options.itemsPerPage) {
        options.params.limit = this.options.itemsPerPage;
      } else {
        options.params.limit = 10;
      }

      if (this.options && this.options.page) {
        options.params.page = this.options.page;
      }

      if (this.status) {
        options.params.status = this.status;
      }

      const res = await StampRewardDeliveryModel.list(options);
      const { data } = res;
      this.items = (data && data.data) || [];
      this.countItems = (data && data.total) || 0;
      this.loading = false;
    },
    _getByQuery() {
      this.options.page = 1;
      this.fetchData();
    },
    async _export() {
      this.loading = true;
      let options = {
        params: {
          cardId: this.id,
          listType: "all",
        },
      };

      if (this.search) {
        options.params.query = this.search;
      }

      if (this.status) {
        options.params.status = this.status;
      }

      let filename = "Reward_delivery.xlsx";
      const res = await StampRewardDeliveryModel.download(options);
      filename = `Reward_delivery_${moment().format("YYMMDD_HHmmss")}.xlsx`;
      fileDownload(res.data, filename);
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
$green: green;
$yellow: orange;
$blue: blue;

.green-text {
  color: $green;
}
.yellow-text {
  color: $yellow;
}
.blue-text {
  color: $blue;
}
.theme--light.v-sheet--outlined {
  border: none !important;
}
</style>
